<form [formGroup]="formGroup" [formGroup]="formGroup" *ngIf="formGroup" autocomplete="off" novalidate #formRef="ngForm">
  <div class="modal-header">
    <h5 class="card-title" *ngIf="user">
      Editar
    </h5>
    <h5 class="card-title" *ngIf="!user">
      Crear
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="user=null;activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="card shaded-card">
    <div class="card-body container-fluid">


      <div class="row">
        <div class="form-group col">
          <label>Tipo identificación</label>
          <select class="form-control form-select" formControlName="identificationType"
            [ngClass]="{ 'is-invalid': controls['identificationType'].errors && formRef.submitted }">
            <option [ngValue]="null">Seleccione</option>
            <option [ngValue]="type.value" *ngFor="let type of indentificationTypes">
              {{type.title}}
            </option>
          </select>
          <div *ngIf="formRef.submitted && controls['identificationType'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>

        <div class="form-group col">
          <label>Número de identificación</label>
          <input type="text" class="form-control" formControlName="identificationNumber"
            [ngClass]="{ 'is-invalid': controls['identificationNumber'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['identificationNumber'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col">
          <label>Nombre</label>
          <input type="text" class="form-control" formControlName="name"
            [ngClass]="{ 'is-invalid': controls['name'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['name'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>

        <div class="form-group col">
          <label>Apellido</label>
          <input type="text" class="form-control" formControlName="lastName"
            [ngClass]="{ 'is-invalid': controls['lastName'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['lastName'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col">
          <label>Teléfono</label>
          <input type="text" class="form-control" formControlName="phone"
            [ngClass]="{ 'is-invalid': controls['phone'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['phone'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>

        <div class="form-group col">
          <label>Correo electrónico</label>
          <input type="email" class="form-control" formControlName="email"
            [ngClass]="{ 'is-invalid': controls['email'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['email'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col">
          <label>Contraseña</label>
          <input type="password" class="form-control" formControlName="password"
            [ngClass]="{ 'is-invalid': controls['password'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['password'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>

        <div class="form-group col">
          <label>Confirmar contraseña</label>
          <input type="password" class="form-control" formControlName="password2"
            [ngClass]="{ 'is-invalid': controls['password2'].errors && formRef.submitted }">
          <div *ngIf="formRef.submitted && controls['password2'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col">
          <label>Sexo</label>
          <select class="form-control form-select" formControlName="sex"
            [ngClass]="{ 'is-invalid': formRef.submitted && controls['sex'].errors }">
            <option ngValue="M">Masculino</option>
            <option ngValue="F">Femenino</option>
            <option [ngValue]="''">Otro</option>
          </select>
          <div *ngIf="formRef.submitted && controls['sex'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>

        <div class="form-group col">
          <label>Estado</label>
          <select class="form-control form-select" formControlName="active"
            [ngClass]="{ 'is-invalid': formRef.submitted && controls['active'].errors }">
            <option [ngValue]="null">Seleccione</option>
            <option [ngValue]="true">Activo</option>
            <option [ngValue]="false">Inactivo</option>
          </select>
          <div *ngIf="formRef.submitted && controls['active'].errors" class="invalid-feedback">
            Este campo es requerido
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="user=null;activeModal.close()">
      Cancelar
    </button>
    <button type="submit" class="btn btn-primary" (click)="onSave()">
      Guardar
    </button>
  </div>
</form>